/**
 * 一覧の金額のセル：税込を上に、下の段に小さく（税抜）。外注のタブと同じ見せ方（9/28 射場さん）。
 * 案件の画面（見積・請求書の行）と案件の一覧の「受注（税込）」（#94）で使う。td.amt の中に置く（styles.css の .amt-ex）
 */
import { yen } from "../lib/num.js";

export function AmtCell({ inc, ex, testId }: { inc: number; ex: number; testId?: string }) {
  return (
    <>
      <span className="amt-inc">{yen(inc)} 円</span>
      <span className="amt-ex" data-testid={testId}>（税抜 {yen(ex)} 円）</span>
    </>
  );
}
